import { PivotFilterOperatorEnum } from '@ztechapps/common.contract'

/** Whether a pivot filter operator takes two operands — `between` and `not_between`. */
export const isPivotRangeOperator = (operator: PivotFilterOperatorEnum): boolean =>
  operator === PivotFilterOperatorEnum.between || operator === PivotFilterOperatorEnum.not_between
